import React from 'react'
import { useProjectListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { projectListFieldConfig as fieldsCore } from './constants'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import type { SetOptional } from 'type-fest'
import type { Project } from '@ztechapps/common.contract'

export const ProjectList = ({
  row,
  head,
  fields,
  listResult,
  tableOptions,
  ...props
}: SetOptional<DataTableProps<Project>, 'listResult' | 'fields'>) => {
  const { projectList, projectListWithSelection } = useProjectListContext()
  const { list } = projectListWithSelection
  const defaultListResult = { ...projectList, list }
  return (
    <DataTable
      fields={fields ?? fieldsCore}
      listResult={listResult ?? defaultListResult}
      row={row ?? ListRow}
      head={head ?? ListHeader}
      tableOptions={{
        ...tableOptions,
        responsive: true,
      }}
      stats={'projects'}
      {...props}
    />
  )
}
